module.exports = __webpack_public_path__ + "static/img/img_4.f0c1d316.jpg";